export default class Count {
    constructor(label) {
        this._label = label;
        this._count = 0;
    }

    get label() {
        return this._label;
    }

    get count() {
        return this._count;
    }

    set count(cnt) {
        this._count = Math.max(0, cnt);
    }

    increment() {
        this._count++;
    }

    decrement() {
        if (this.count > 0) {
            this._count--;
        }
    }
}